import { TLEditorSnapshot } from '@tldraw/tldraw';
import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface GetChronologyVisualisationParams {
  caseId: string | null;
  chronologyId: string | null;
}

interface ChronologyVisualisationResponse {
  snapshot: TLEditorSnapshot;
}

export const useGetChronologyVisualisation = ({ caseId, chronologyId }: GetChronologyVisualisationParams) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useQuery(
    [QueryEntity.ChronologyVisualisation, caseId, chronologyId],
    async (): Promise<ChronologyVisualisationResponse | null> => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.GET,
      });

      const response = await fetch(
        `${APIBaseChronos}/api/case/${caseId}/chronology/${chronologyId}/visualisation`,
        fetchConfig,
      );

      if (response.status === 404 || !response.ok) {
        // No saved visualisation found
        return null;
      }

      return response.json();
    },
    {
      enabled: !!caseId && !!chronologyId,
      retry: false,
      refetchOnMount: true,
      staleTime: 0,
      refetchOnWindowFocus: false,
    },
  );
};
